import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUnavailableCircle = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.63604 5.63604C4.00736 7.26472 3 9.51472 3 12C3 16.9706 7.02944 21 12 21C14.4853 21 16.7353 19.9926 18.364 18.364M5.63604 5.63604C7.26472 4.00736 9.51472 3 12 3C16.9706 3 21 7.02944 21 12C21 14.4853 19.9926 16.7353 18.364 18.364M5.63604 5.63604L18.364 18.364",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgUnavailableCircle;
